import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const setPrimarySSOProvider = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    provider: { kind: "ssoProvider", from: "id" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { provider } }) => {
    if (provider.isPrimary) return;
    const [current] = await tx.run(
      zql.ssoProvider.where("tenantId", ctx.tenantId).where("isPrimary", true)
    );
    const now = Date.now();
    // Demote before promoting: the one-primary-per-tenant unique index is
    // checked per statement.
    if (current) {
      await tx.mutate.ssoProvider.update({
        id: current.id,
        isPrimary: false,
        updatedAt: now,
      });
    }
    await tx.mutate.ssoProvider.update({
      id: provider.id,
      isPrimary: true,
      updatedAt: now,
    });
  },
});
